import React, { useEffect, useState } from "react";
import smoothscroll from "smoothscroll-polyfill";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import { useGlobalStateContext } from "../../context/globalContext";
import {
  changePage,
  changeSubjectPage,
  fetchArticles,
  getArticlesByTag,
  getArticlesByCategory,
  getSingleArticle,
  changeTagPage,
  getCreatorInfo,
  searchArticles,
  getVacancies,
} from "../../store/actions";

import { RouteMatchProps } from "../../types";

// Components
import Header from "../Header";
import LoginModal from "../LoginModal";
import Grid from "../Grid";
import Footer from "../Footer";
import Cookies from "../Cookies";

// Pages
import Search from "../../pages/Search";
import Article from "../../pages/Article";
import Author from "../../pages/Author";
import Careers from "../../pages/Careers";
import Vacancy from "../../pages/Vacancy";
import NotFound from "../../pages/NotFound";

// Style
import GlobalStyle from "../../utilities/GlobalStyle";
import { userInfo } from "os";

const App = () => {
  const [popupVisibility, setPopupVisibility] = useState<boolean>();
  let location = useLocation();
  const { context } = useGlobalStateContext();
  const caseStudyPage = useRouteMatch<RouteMatchProps>("/case-study");
  const caseStudy = useRouteMatch<RouteMatchProps>("/:category/:id");
  const careers = useRouteMatch<RouteMatchProps>("/careers");
  const vacancy = useRouteMatch<RouteMatchProps>("/careers/:id");

  useEffect(() => {
    if (typeof window !== "undefined") {
      smoothscroll.polyfill();
    }
  }, []);

  useEffect(() => {
    // window && window.scrollTo({ top: 0 });

    if (!caseStudy && !careers) {
      context.setIsCaseStudy(false);
      document.body.id = "";
    }

    if (caseStudy) {
      context.setIsCaseStudy(false);
      document.body.id = "";
    }

    if (careers || vacancy || caseStudyPage ) {
      context.setIsCaseStudy(true);
      document.body.id = "case-study";
    }
  }, [location, caseStudy, context]);

  return (
    <>
      <GlobalStyle />
      <LoginModal
        hasWhiteBackground={caseStudy || careers || vacancy || caseStudyPage}
        popupVisibility={popupVisibility}
        setPopupVisibility={setPopupVisibility}
      />
      <Header />
      <div id="website">
        <Switch>
          <Route path="/tag" exact component={Grid} />
          <Route path="/careers" exact component={Careers} />
          <Route path="/careers/:id" exact component={Vacancy} />
          <Route path="/tag/:tag" exact component={Grid} />
          <Route path="/search" exact component={Search} />
          <Route path="/search/:queryText" exact component={Search} />
          <Route path="/author" exact component={Grid} />
          <Route path="/author/:author" exact component={Author} />
          <Route path="/:category/:id" exact component={Article} />
          <Route path="/magazine" exact component={Grid} />
          <Route path="/:category" exact component={Grid} />
          <Route component={NotFound} />
        </Switch>
        <Footer
          popupVisibility={popupVisibility}
          setPopupVisibility={setPopupVisibility}
        />
        {typeof window !== "undefined" && <Cookies />}
      </div>
    </>
  );
};

App.getInitialProps = async (param: any) => {
  const articlesPerPage: number = 6;
  const { store, match, req } = param;
  if (typeof window === "undefined") {
    // await store.dispatch(getTotalArticles())
    if (match && match.url !== "/favicon.ico") {
      switch (match.path) {
        case "/magazine":
          if (req.query.page) {
            await store.dispatch(
              changePage({ page: req.query.page, articlesPerPage })
            );
          } else {
            await store.dispatch(fetchArticles(articlesPerPage));
          }
          break;
        case "/:category":
          const category = match.params.category;
          if (req.query.page) {
            await store.dispatch(
              changeSubjectPage({
                category,
                page: req.query.page,
                articlesPerPage,
              })
            );
          } else {
            await store.dispatch(
              getArticlesByCategory({ category, articlesPerPage })
            );
          }
          break;
        case "/careers":
          await store.dispatch(getVacancies());
          break;
        case "/careers/:id":
          await store.dispatch(getVacancies());
          break;
        case "/:category/:id":
          const id = match.params.id;
          await store.dispatch(getSingleArticle(id));
          break;
        case "/tag/:tag":
          const tag = match.params.tag;
          if (req.query.page) {
            await store.dispatch(
              changeTagPage({ tag, page: req.query.page, articlesPerPage })
            );
          } else {
            await store.dispatch(getArticlesByTag({ tag, articlesPerPage }));
          }
          break;
        case "/search/:queryText":
          const text = match.params.queryText;
          await store.dispatch(searchArticles(text));
          break;
        case "/author/:author":
          await store.dispatch(getCreatorInfo(match.params.author));
          break;
      }
    }
  }
};

export default App;
